/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NewMessageConversationSubscribeInput = {
    conversationId: string;
};
export type DisplayConversationNewMessageSubscriptionVariables = {
    input: NewMessageConversationSubscribeInput;
};
export type DisplayConversationNewMessageSubscriptionResponse = {
    readonly newMessageConversation: {
        readonly " $fragmentRefs": FragmentRefs<"DisplayConversation_message">;
    } | null;
};
export type DisplayConversationNewMessageSubscription = {
    readonly response: DisplayConversationNewMessageSubscriptionResponse;
    readonly variables: DisplayConversationNewMessageSubscriptionVariables;
};



/*
subscription DisplayConversationNewMessageSubscription(
  $input: NewMessageConversationSubscribeInput!
) {
  newMessageConversation(input: $input) {
    ...DisplayConversation_message
    id
  }
}

fragment DisplayConversation_message on ConversationMessage {
  text
  source
  user {
    id
    name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisplayConversationNewMessageSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConversationMessage",
        "kind": "LinkedField",
        "name": "newMessageConversation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DisplayConversation_message"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisplayConversationNewMessageSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConversationMessage",
        "kind": "LinkedField",
        "name": "newMessageConversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "43b7c157ef09bd89d2f35ce29633ec5d",
    "id": null,
    "metadata": {},
    "name": "DisplayConversationNewMessageSubscription",
    "operationKind": "subscription",
    "text": "subscription DisplayConversationNewMessageSubscription(\n  $input: NewMessageConversationSubscribeInput!\n) {\n  newMessageConversation(input: $input) {\n    ...DisplayConversation_message\n    id\n  }\n}\n\nfragment DisplayConversation_message on ConversationMessage {\n  text\n  source\n  user {\n    id\n    name\n  }\n}\n"
  }
};
})();
(node as any).hash = '1a21b33a29d93c12514ef6fa87206ccb';
export default node;
